import axios from 'axios'
import store from '../store'
import { Loading,Message } from 'element-ui'

// 创建一个axios实例
const axiosInstance = axios.create({
  // 在env进行配置，分配配置开发环境生产环境的 VUE_APP_BASE_API，
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 600000
})
// let loadingInstanceMap: any = {}

axiosInstance.interceptors.request.use(
  (config: any) => {
    var options: any = {}
    // 配置请求时的loading
    if (config.loadingOptions) {
      options = config.loadingOptions
      if (!options.target) {
        options.target = 'app'
      }

      let loadingInstance = Loading.service(options)
      config.loadingInstance = loadingInstance
    }
    // 在header配置请求的token
    // if (store.getters.token) {
    //   config.headers['Authorization'] = store.getters.token ? 'Bearer ' + store.getters.token : ''
    // }
      if (store.getters.token &&config && config.url!='/user/signin') {
          config.headers['Authorization'] = store.getters.token ? 'Bearer ' + store.getters.token : ''
      }
    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)
axiosInstance.interceptors.response.use(
  response => {
    var loadingInstance = (response.config as any).loadingInstance
    if (loadingInstance) {
      loadingInstance.close()
    }
    return response
  },
  error => {
    var loadingInstance = (error.config as any).loadingInstance
    if (loadingInstance) {
      loadingInstance.close()
    }
    console.log(error.response) // for debug
    let msg = ''
    if (error.response) {
      switch (error.response.status) {
        case 401:
          msg = error.response.data.msg
          // if (error.response.data.error === 'invalid_token') {
            //token错误时执行退出登录操作{401 invalid_token}
            store.commit('logout')
            sessionStorage.removeItem("triman_bsrkapp_store")
          // }
          break
        case 503:
          msg = error.response.data.message
          break
        case 500:
          msg = error.response.data.message
          Message({
            message: msg,
            type: "error",
            duration: 1500
          })
          break
        default:
          msg = error.message
      }
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
